import React from 'react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

export function Footer() {
	return (
		<footer className={styles['footer']}>
			<div>
				<ContactUs />
				<Links />
				<Address />
			</div>
		</footer>
	);
}

function ContactUs() {
	return (
		<section>
			<h2>Contact Us</h2>
			<p>
				We provide the leadership, advocacy, training and tools that
				empower California’s hospitals and health systems to do their
				best work.
			</p>
			<p>info@calhospital.org</p>
			<p>
				© <strong> 2026 California Hospital Association</strong>
			</p>
		</section>
	);
}

function Links() {
	return (
		<section>
			<h2>Webinars</h2>

			<a
				href="https://calhospital.org/events/"
				rel="noreferrer"
				target={'_blank'}
			>
				Upcoming Programs
			</a>
			<a
				href="https://calhospital.org/education-publications/cha-on-demand-learning/#on-demand-recordings"
				rel="noreferrer"
				target={'_blank'}
			>
				On-Demand Learning
			</a>
			<h2>Links</h2>

			<a
				href="https://calhospital.org/publications/forms-and-appendices/"
				rel="noreferrer"
				target={'_blank'}
			>
				Sample Forms
			</a>
			<Link to="/archive">Archive</Link>
		</section>
	);
}

function Address() {
	return (
		<section>
			<h2>Sacramento Office</h2>
			<p>
				1215 K Street, Suite 700
				<br />
				Sacramento, CA 95814
				<br />
				(916) 443-7401
				<br />
				Fax: (916) 552-7596
				<br />
			</p>
			<h2>Washington D.C. Office</h2>
			<p>
				499 South Capitol Street SW, Suite 410 <br />
				Washington, D.C. 20003 <br />
				(202) 488-3740
			</p>
		</section>
	);
}
